import { Component, OnInit } from '@angular/core';
import { PpsUtilityService } from '../services/pps-utility.service';
import { Timesheet } from '../shared/models/timesheet';
import { lastDayOfWeek } from 'date-fns';
import { IJobCode } from '../shared/models/job-code';
import { NgForm } from '@angular/forms';
import { IRosterCode } from '../shared/models/roster-code';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { TimesheetService } from '../services/timesheet.service';

@Component({
  selector: 'pps-time-sheet-form',
  templateUrl: './timesheet-form.component.html',
  styleUrls: ['./timesheet-form.component.css']
})
export class TimesheetFormComponent implements OnInit {
  private _timesheet: Timesheet;
  private _hoursBeforeUpdate = 0;
  parent: any = null;

  jobCodes: IJobCode[] = [];
  rosterCodes: IRosterCode[] = [];
  employeeName: string = "";
  maxDate: Date;

  constructor(private _dialogRef: DynamicDialogRef,
              private _dialogConfig: DynamicDialogConfig,
              private _confirmationService: ConfirmationService,
              private _timesheetService: TimesheetService,
              private util: PpsUtilityService) { }

  private initializeDialog(){
    this.parent = this._dialogConfig.data.parent;
    this.timesheet = this._dialogConfig.data.timesheet;
    this.jobCodes = this._dialogConfig.data.jobCodes;
    this.rosterCodes = this._dialogConfig.data.rosterCodes;
  }    

  ngOnInit(): void {
    this.maxDate = lastDayOfWeek(new Date());
    this.initializeDialog();
  }

  set timesheet(timesheet: Timesheet){
    this._timesheet = timesheet;
    this._hoursBeforeUpdate = timesheet.hours;
  }

  get timesheet(){
    return this._timesheet;
  }

  save(form: NgForm){
    if (form.invalid){
      return;
    }

    let hoursEntered = this.parent.getHoursEntered(this.timesheet.employee.id, this.timesheet.day);
    let totalHours = hoursEntered - this._hoursBeforeUpdate + this.timesheet.hours;
    var warning = this._timesheetService.getWarningMessage(this.timesheet, totalHours, true);
    if (warning.type > 0){
      this._confirmationService.confirm({
        header: "Warning",
        message: warning.message,
        icon: "fas fa-exclamation-triangle icon-danger",
        defaultFocus: "accept",
        accept: () => {
          this._dialogRef.close(this.timesheet);
        }});
    }else{
      this._dialogRef.close(this.timesheet);
    }
  }

  cancel(){
    this._dialogRef.close();
  }

  canModifyPastTimeSheet(): boolean{
    return this.parent.canModifyPastTimeSheet();
  }
}
